import React, { useState } from 'react';
import { Accordion, Card, Container, Row, Col, Form,Button } from 'react-bootstrap';

const desktopVideos = [
  {
    src: "https://player.vimeo.com/video/917382074?h=54058badef&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
    title: "Messaging",
  },
  // {
  //   src: "https://player.vimeo.com/video/917382316?h=1e19201535&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
  //   title: "Sending a Repeat Prescription Request",
  // },
  {
    src: "https://player.vimeo.com/video/1055461477?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479%22",
    title: "Repeat Prescription Requests with Payment in Advance",
  },
  {
    src: "https://player.vimeo.com/video/917381524?h=c08dec3dd0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
    title: "Booking an Appointment",
  },
  // Add more desktop/laptop videos here
];

const mobileVideos = [
  {
    src: "https://player.vimeo.com/video/917382755?h=dfd8b0a182&badge=0&autopause=0&player_id=0&app_id=58479",
    title: "Booking an Appointment with your Provider",
  },
  // {
  //   src: "https://player.vimeo.com/video/917383296?h=c3372d7878&badge=0&autopause=0&player_id=0&app_id=58479",
  //   title: "Requesting a Repeat Prescription",
  // },
  {
    src: "https://player.vimeo.com/video/917383886?h=57c2658788&badge=0&autopause=0&player_id=0&app_id=58479",
    title: "Sending a Message to your Provider",
  },
  {
    src: "https://player.vimeo.com/video/917382965?h=e6ce37ab9d&badge=0&autopause=0&player_id=0&app_id=58479",
    title: "Paying a Bill",
  },
  // Add more mobile app videos here
];

const FAQs: React.FC = () => {
  // State for search query
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [filteredDesktopVideos, setFilteredDesktopVideos] = useState(desktopVideos);
  const [filteredMobileVideos, setFilteredMobileVideos] = useState(mobileVideos);

  // Function to handle search
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    
    const filteredDesktop = desktopVideos.filter(video => video.title.toLowerCase().includes(query));
    setFilteredDesktopVideos(filteredDesktop);
    
    const filteredMobile = mobileVideos.filter(video => video.title.toLowerCase().includes(query));
    setFilteredMobileVideos(filteredMobile);
  };
  const [mobileAccordionActiveKey, setMobileAccordionActiveKey] = useState<any | null>('0');
  const [desktopAccordionActiveKey, setDesktopAccordionActiveKey] = useState<any | null>('0');

 // Function to handle expand all
const handleExpandAll = () => {
  const allEventKeys = filteredMobileVideos.map((_, index) => index.toString());
  console.log("keys",allEventKeys)
  // setExpandedItems(allEventKeys);
  setMobileAccordionActiveKey(allEventKeys);
  const allEventKeys1 = filteredDesktopVideos.map((_, index) => index.toString());
  setDesktopAccordionActiveKey(allEventKeys1);
};
 
const handleCollapseAll = () => {
  setMobileAccordionActiveKey(null);
  setDesktopAccordionActiveKey(null);
};
  return (
    <Container fluid>
      <Container className="py-5">
        <Row>
          <Col md={2}></Col>
          <Col md={8}>
            <Row>
              <Col md={6}>
                <h1 className='mb-4 myindici-heading'>Videos</h1>
              </Col>
              <Col md={6}>
              <Form.Group>
              <Form.Control
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={handleSearch}
              />
            </Form.Group>
              </Col>
            </Row>
          </Col>
          <Col md={2}></Col>
        </Row>
        <Row>
      
          <Col md={2}></Col>
          <Col md={8}>
            <Row className="mb-3">
              <Col md={6}></Col>
              <Col md={2}></Col>
              <Col md={2} className="">
                <Button onClick={handleExpandAll} className='w-100 expandAll'>
                  Expand All
                </Button>
              </Col>
              <Col md={2} className="d-flex justify-content-around">
                <Button variant="secondary" onClick={handleCollapseAll} className='w-100 collapsAll'>
                  Collapse All
                </Button>
              </Col>
              <Col md={12} className='mt-5 mb-5 d-flex justify-content-center'>
          <span className='videosTutorial text-center'>Mobile App</span></Col>
            </Row>
            <Accordion activeKey={mobileAccordionActiveKey} onSelect={(key:any) => setMobileAccordionActiveKey(key)}>
              {filteredMobileVideos.map((video, index) => (
                <Card key={index}>
                  <Accordion.Item eventKey={index.toString()}>
                    <Accordion.Header>{video.title}</Accordion.Header>
                    <Accordion.Body>
                      <div style={{ padding: '56.37% 0 0 0', position: 'relative' }}>
                        <iframe
                          src={video.src}
                          frameBorder="0"
                          allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                          title={video.title}
                          className='vimovideo'
                        ></iframe>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Card>
              ))}
            </Accordion>
            </Col>
            </Row>
        <Row>
          <Col md={12} className='mt-5 mb-5 d-flex justify-content-center'>
              <span className='videosTutorial text-center'>Desktop/Laptop </span></Col>
          <Col md={2}></Col>
          <Col md={8}>
          <Accordion activeKey={desktopAccordionActiveKey} onSelect={(key:any) => setDesktopAccordionActiveKey(key)}>
              {filteredDesktopVideos.map((video, index) => (
                <Card key={index}>
                  <Accordion.Item eventKey={index.toString()}>
                    <Accordion.Header>{video.title}</Accordion.Header>
                    <Accordion.Body className=''>
                      <div style={{ padding: '56.37% 0 0', position: 'relative' }}>
                        <iframe
                          src={video.src}
                          frameBorder="0"
                          allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                          title={video.title}
                        ></iframe>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Card>
              ))}
            </Accordion>
          </Col>
          <Col md={2}></Col>
        </Row>
      </Container>
    </Container>
  );
}

export default FAQs;
